module.exports = "/assets/hero-carrot@2x.png?4gMxY3H";